import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Spinner, Alert } from 'react-bootstrap';
import api from '../services/api';

function Dashboard() {
  const [stats, setStats] = useState({
    convocatorias: 0,
    ordenes: 0,
    cotizaciones: 0,
    usuarios: 0
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      setLoading(true);
      const [convocatoriasRes, ordenesRes, cotizacionesRes, usuariosRes] = await Promise.all([
        api.get('/api/v1/convocatorias/'),
        api.get('/api/v1/ordenes/'),
        api.get('/api/v1/cotizaciones/'),
        api.get('/api/v1/usuarios/')
      ]);

      setStats({
        convocatorias: convocatoriasRes.data?.length || 0,
        ordenes: ordenesRes.data?.length || 0,
        cotizaciones: cotizacionesRes.data?.length || 0,
        usuarios: usuariosRes.data?.length || 0
      });
    } catch (err) {
      console.error('Error loading stats:', err);
      setError('Error al cargar las estadísticas');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
        <div className="text-center">
          <Spinner animation="border" variant="primary" style={{ width: '3rem', height: '3rem' }} />
          <p className="mt-3 text-muted">Cargando datos...</p>
        </div>
      </div>
    );
  }

  const statCards = [
    {
      title: 'Convocatorias',
      value: stats.convocatorias,
      icon: 'bi-file-earmark-text',
      color: '#2b3e53',
      bgColor: 'rgba(43, 62, 83, 0.1)',
      iconBg: 'rgba(43, 62, 83, 0.15)'
    },
    {
      title: 'Órdenes',
      value: stats.ordenes,
      icon: 'bi-cart-check',
      color: '#10b981',
      bgColor: 'rgba(16, 185, 129, 0.1)',
      iconBg: 'rgba(16, 185, 129, 0.15)'
    },
    {
      title: 'Cotizaciones',
      value: stats.cotizaciones,
      icon: 'bi-file-earmark-spreadsheet',
      color: '#f59e0b',
      bgColor: 'rgba(245, 158, 11, 0.1)',
      iconBg: 'rgba(245, 158, 11, 0.15)'
    },
    {
      title: 'Usuarios',
      value: stats.usuarios,
      icon: 'bi-people',
      color: '#3b82f6',
      bgColor: 'rgba(59, 130, 246, 0.1)',
      iconBg: 'rgba(59, 130, 246, 0.15)'
    }
  ];

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h1 className="h3 mb-1 fw-bold" style={{ color: '#1e293b' }}>Dashboard</h1>
          <p className="text-muted mb-0">Resumen general del sistema</p>
        </div>
      </div>

      {error && (
        <Alert variant="danger" dismissible onClose={() => setError('')} className="mb-4 border-0 shadow-sm">
          <i className="bi bi-exclamation-triangle-fill me-2"></i>
          {error}
        </Alert>
      )}

      <Row className="g-4 mb-4">
        {statCards.map((stat, index) => (
          <Col md={6} lg={3} key={index}>
            <Card className="h-100 border-0 shadow-sm" style={{ 
              borderRadius: '16px',
              transition: 'all 0.3s ease',
              border: `1px solid ${stat.bgColor}`
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-4px)';
              e.currentTarget.style.boxShadow = '0 10px 25px rgba(0, 0, 0, 0.1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 1px 3px rgba(0, 0, 0, 0.1)';
            }}>
              <Card.Body className="p-4">
                <div className="d-flex justify-content-between align-items-start mb-3">
                  <div style={{
                    width: '48px',
                    height: '48px',
                    borderRadius: '12px',
                    backgroundColor: stat.iconBg,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <i className={`${stat.icon}`} style={{ fontSize: '1.5rem', color: stat.color }}></i>
                  </div>
                </div>
                <div>
                  <p className="text-muted mb-1 small fw-semibold text-uppercase" style={{ fontSize: '0.75rem', letterSpacing: '0.5px' }}>
                    {stat.title}
                  </p>
                  <h2 className="mb-0 fw-bold" style={{ color: stat.color, fontSize: '2rem' }}>
                    {stat.value}
                  </h2>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      <Row className="mt-4">
        <Col>
          <Card className="border-0 shadow-sm" style={{ borderRadius: '16px' }}>
            <Card.Body className="p-4">
              <div className="d-flex align-items-center mb-3">
                <div style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '10px',
                  backgroundColor: 'rgba(43, 62, 83, 0.1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: '12px'
                }}>
                  <i className="bi bi-info-circle" style={{ fontSize: '1.25rem', color: '#2b3e53' }}></i>
                </div>
                <h5 className="mb-0 fw-bold">Información del Sistema</h5>
              </div>
              <p className="text-muted mb-0" style={{ lineHeight: '1.7' }}>
                Sistema de gestión de convocatorias, órdenes y cotizaciones para la Dirección Regional de Salud (DIRESA).
                Utilice el menú lateral para navegar entre las diferentes secciones del sistema.
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default Dashboard;
